import { Checkbox, Radio } from '@mantine/core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TransformValues } from 'src/types/transform-values.type';
import getNestedValue from 'src/Utils/getNestedValue';

import styles from './EventCreationDayPicker.module.scss';
import { Props } from './EventCreationDayPicker.types';

const EventCreationDayPicker = <T, O extends TransformValues<T>>({
  form,
  pathMonthDayNumberOrAdvanced = 'recurrence.monthDayNumberOrAdvanced',
  pathByMonthDays = 'recurrence.byMonthDays',
}: Props<T, O>) => {
  const days = useMemo(() => Array.from(Array(31).keys()).map(i => i + 1), []);
  const { t } = useTranslation();

  const monthDayNumberOrAdvancedValue = getNestedValue(form.values, pathMonthDayNumberOrAdvanced);
  const byMonthDaysValue = getNestedValue(form.values, pathByMonthDays) || [];

  const disabled = monthDayNumberOrAdvancedValue === 'advanced';

  return (
    <div className={styles.container}>
      <div className={styles.checkboxLine}>
        <Radio value={'number'} />
        <div className={styles.label}>{t('createEventForm.every', 'Tous les')}</div>
      </div>
      <div className={styles.days}>
        {days.map(day => {
          const toggleDay = (checked?: boolean) => {
            const selectedDays = byMonthDaysValue;
            const isCurrentlySelected = checked ?? selectedDays.includes(day.toString());

            const newMonths = !isCurrentlySelected
              ? [...selectedDays, day.toString()]
              : selectedDays.filter((m: string) => m !== day.toString());

            form.setFieldValue(pathByMonthDays, newMonths);
          };

          return (
            <Checkbox
              disabled={disabled}
              key={day.toString()}
              label={day.toString()}
              className={styles.checkbox}
              checked={byMonthDaysValue.includes(day.toString())}
              onChange={event => toggleDay(event.currentTarget.checked)}
              wrapperProps={{
                onClick: () => {
                  if (!disabled) toggleDay();
                },
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default EventCreationDayPicker;
